module.exports = __webpack_public_path__ + "static/teetherorganic1-54b75af8ed5a5dd5c78f00c5d1d2bfcc.jpeg";